import apiClient from './apiClient';

const BASE = '/datos-maestros/tipos-turno';

// Catálogo de tipos de turno (a qué vino la persona). Vive en la base y no en el código porque la
// lista la maneja el estudio y cambia. Antes estaba duplicada en cuatro lugares desincronizados:
// un Map en el backend, dos constantes en el front y la propia planilla — y el turnero ofrecía
// tipos que el backend no aceptaba, así que el turno se guardaba como "consulta general".

/** @param soloActivos true para los selectores de alta; false para administrarlos. */
export async function listarTiposTurno(soloActivos = true) {
    const { data } = await apiClient.get(BASE, { params: { soloActivos } });
    return Array.isArray(data) ? data : [];
}

export async function crearTipoTurno(tipo) {
    const { data } = await apiClient.post(BASE, tipo);
    return data;
}

export async function actualizarTipoTurno(id, tipo) {
    const { data } = await apiClient.put(`${BASE}/${id}`, tipo);
    return data;
}

/** Solo si nadie lo usó. Si tiene turnos, el backend pide desactivarlo en su lugar. */
export async function eliminarTipoTurno(id) {
    const { data } = await apiClient.delete(`${BASE}/${id}`);
    return data;
}
